import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[inputPrefix]' // tslint:disable-line
})
export class InputPrefixDirective<T = any> {
  @Input() public inputPrefix;
  constructor(public templateRef: TemplateRef<T>) {}
}
